module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " weex-ct weex-div",
    style: (_vm._px2rem(_vm.containerS, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    ref: ("sliderCtn_" + _vm.sliderId),
    staticClass: " weex-ct weex-div",
    style: ({
      width: _vm._px2rem(_vm.cardWidth + 'px', 75),
      height: _vm._px2rem(_vm.cardS.height + 'px', 75),
      transform: _vm._px2rem(("translateX(-" + (_vm.currentIndex * (_vm.cardS.width + _vm.cardS.spacing)) + "px)"), 75)
    }),
    attrs: {
      "weex-type": "div",
      "data-evt-panstart": "",
      "data-evt-panmove": "",
      "data-evt-panend": "",
      "data-evt-horizontalpan": ""
    },
    on: {
      "panstart": function($event) {
        $event.stopPropagation();
        return _vm.onPanStart($event)
      },
      "panmove": function($event) {
        $event.stopPropagation();
        return _vm.onPanMove($event)
      },
      "panend": function($event) {
        $event.stopPropagation();
        return _vm.onPanEnd($event)
      },
      "horizontalpan": _vm.onEpPanStart
    }
  }, [_vm._l((_vm.cardList), function(v, index) {
    return _c('div', {
      ref: ("card" + index + "_" + _vm.sliderId),
      refInFor: true,
      staticClass: "slider weex-ct weex-div",
      style: ({
        transform: _vm._px2rem(("scale(" + (index === _vm.currentIndex ? 1 : _vm.cardS.scale) + ")"), 75),
        left: _vm._px2rem(((index * (_vm.cardS.width + _vm.cardS.spacing)) + "px"), 75),
        marginLeft: _vm._px2rem((((_vm.containerS.width - _vm.cardS.width) / 2) + "px"), 75),
        width: _vm._px2rem(_vm.cardS.width + 'px', 75),
        height: _vm._px2rem(_vm.cardS.height + 'px', 75)
      }),
      attrs: {
        "weex-type": "div"
      }
    }, [_vm._t(("card" + index + "_" + _vm.sliderId), null, {})], 2)
  }), _vm._v(" "), _vm._t("pull-more", null, {})], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3f5fd022", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f5fd022","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/wxc-ep-slider/index.vue
// module id = 221
// module chunks = 0 1